import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Box,
  Spinner,
  Image,
} from "@chakra-ui/react";
import CustomRecurrencePage from "./RecurrenceComponent";
import { baseURL } from "../../utils/config";
import { useSelector } from "react-redux";
import { Flex, Select, Tooltip, TreeSelect } from "antd";
import { GoGoal } from "react-icons/go";
import { getAvatarColor, getInitials } from "../../utils/helpers";
import dayjs from "dayjs";
import { toast, ToastContainer } from "react-toastify";
import { api } from "../../components/global/api";
import { useNavigate } from "react-router-dom";

const ScheduleMeetingModal = ({
  isOpen,
  onClose,
  setformData,
  formData,
  Schedule,
}) => {
  const [template, setTemplate] = useState([]);
  const user = useSelector((state) => state.user);
  const currentUser = user?.currentUser;
  const currentEmployee = currentUser?.employees[user?.currentCompany];
  const [participations, setParticipants] = useState(null);
  const [data, setData] = useState({});
  const [parentDropdownItems, setParentDropdownItems] = useState([]);
  const okrSlice = useSelector((state) => state.okr);
  const [isCustomModalOpen, setIsCustomModalOpen] = useState([]);
  const [isgoogleConnected, setIsGoogleConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchCalendarConnect = async () => {
    try {
      const response = await api.get(baseURL + "/integration/google-calendar");
      // setMentions(response.data);
      console.log("Heloo", response);
      if (response?.data) {
        setIsGoogleConnected(response?.data?.status);
      } else {
        setIsGoogleConnected(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [errors, setErrors] = useState({
    name: false,
    templateSelected: false,
    Cadence_schedule: false,
    recurrence: false,
    parent_id: false,
    participations: false,
  });


  useEffect(() => {
    return () => {
      setErrors({
        name: false,
        templateSelected: false,
        Cadence_schedule: false,
        recurrence: false,
        parent_id: false,
        participations: false,
      });
    };
  }, [onClose]); 

  const getStrokeColor = (template_type) => {
    if (template_type === "quarterly_template") {
      return "#92CAC1";
    } else if (template_type === "monthly_template") {
      return "#F4DB77";
    } else {
      return "#EEB0B0";
    }
  };

  function formatLocalDateString(dateString) {
    if (!dateString) return "";
    const [datePart, timePart] = dateString.split("T");
    const [hours, minutes] = timePart?.split(":") || [];
    return `${datePart}T${hours}:${minutes}`;
  }

  const fetchOwnerData = async (goalId) => {
    try {
      const response = await api.get(baseURL + "/goal-user/", {
        goal_id: goalId,
      });
      setParticipants(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCalendarConnect();
    if (formData?.parent_id) {
      fetchOwnerData(formData?.parent_id);
    }
  }, [formData?.parent_id]);

  const fetchData = async () => {
    try {
      const response = await api.get(baseURL + "/template/", {
        company_id: currentEmployee?.company_id,
      });
      const formattedData = response.data.map((template) => ({
        title: (
          <p className="flex gap-x-2 items-center">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.55 1H1V11.1538H9.55V1ZM19 14.8462H1V19H19V14.8462ZM19 1H13.15V4.69231H19V1ZM19 7.46154H13.15V11.1538H19V7.46154Z"
                stroke={getStrokeColor(template?.template_type)}
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
            </svg>
            {template?.template_title}
          </p>
        ),
        value: `${template?.id} ${template?.template_title}`,
        key: template?.id,
      }));

      setTemplate(formattedData);
    } catch (error) {
      console.error(error);
    }
  };

  const getGoalData = async () => {
    try {
      const response = await api.get(baseURL + "/assignparents/", {
        company_id: currentEmployee?.company_id,
        session: okrSlice?.session,
      });
      const tempParentTree = response.data?.map((goal) => {
        return {
          label: (
            <p className="flex gap-x-2 items-center ">
              <button
                className="rounded p-1"
                style={{
                  background:
                    "linear-gradient(140.34deg, rgba(252, 8, 0, 0.29) 9.12%, rgba(253, 64, 64, 0) 92.07%)",
                }}
              >
                <GoGoal
                  className="text-md"
                  style={{
                    color: "#B91C1C",
                    width: "18px",
                    height: "18px",
                  }}
                />
              </button>
              {goal?.title}
            </p>
          ),
          value: goal?.goal_id + " " + "goal",
          type: "goal",
        };
      });
      setParentDropdownItems(tempParentTree);
    } catch (error) {}
  };
  const recurrenceOptions = [
    { title: "One time", value: "one_time", key: "one_time" },
    { title: "Every day", value: "daily", key: "daily" },
    {
      title: "Every week on same day",
      value: "weekly",
      key: "weekly",
    },
    {
      title: "Every month on same day",
      value: "monthly",
      key: "monthly",
    },
    {
      title: "Every year on same date",
      value: "yearly",
      key: "yearly",
    },
    { title: "Custom..", value: "custom", key: "custom" },
  ];

  const ReccurenceData = recurrenceOptions?.map((option) => ({
    title: option.title,
    value: option.value,
    key: option.key,
  }));

  useEffect(() => {
    setformData(null);
    fetchData();
    getGoalData();
    setIsCustomModalOpen(false);
  }, []);

  useEffect(() => {
    fetchData();
    setformData((prevData) => ({
      ...prevData,
      templateSelected: Schedule,
    }));
  }, [Schedule]);

  const handleMeeting = (e) => {
    setformData((prevData) => ({
      ...prevData,
      name: e.target.value,
    }));
  };

  const handleTemplateChange = (value) => {
    setformData((prevData) => ({
      ...prevData,
      templateSelected: value,
    }));
  };

  const handleDateTimeChange = (event) => {
    const localDateTime = event.target.value;

    if (localDateTime) {
      setformData((prevData) => ({
        ...prevData,
        Cadence_schedule: localDateTime,
      }));
    }
  };

  const handleRecurrenceChange = (value) => {
    setformData((prevData) => ({
      ...prevData,
      recurrence: value,
    }));
    if (value === "custom") {
      setIsCustomModalOpen(true);
    }
  };

  const handleCustomModalClose = () => {
    setIsCustomModalOpen(false);
  };

  const validateForm = () => {
    const {
      name,
      templateSelected,
      Cadence_schedule,
      recurrence,
      parent_id,
      participations,
    } = formData;
    const newErrors = {
      name: !name,
      templateSelected: !templateSelected,
      Cadence_schedule: !Cadence_schedule,
      recurrence: !recurrence,
      parent_id: !parent_id,
      participations: participations?.length === 0,
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error);
  };

  const checkTypeAndSave = (newVal) => {
    if (!newVal) return;
    const splitData = newVal?.split(" ");
    if (splitData?.length !== 2) return;
    if (splitData[1] !== "goal") {
      return;
    }
    const parent_id = splitData[0];
    const parent_type = splitData[1];
    setformData({
      ...formData,
      parent_val: newVal,
      parent_id: parent_id,
      parent_type: parent_type,
    });
    fetchOwnerData(parent_id);

    setformData((prevFormData) => {
      const updatedData = {
        ...prevFormData,
        participations: [],
      };
      return updatedData;
    });
  };
  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);

      const payload = {
        goal_id: formData?.parent_id,
        template: formData?.templateSelected?.split(" ")[0],
        company_id: currentEmployee?.company_id,
        name: formData?.name,
        start_time: formData?.Cadence_schedule,
        participations: formData?.participations,
        recurrence: formData?.recurrence,
        ...data,
      };
      const res = await api.post(baseURL + "/schedule/", payload);
      toast.success("Meeting  Scheduled Successfully!");
      setTimeout(() => {
        onClose();
      }, 1000);
    } catch (error) {
      console.error(error);
      toast.error("Please Try Again.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      const payload = {
        schedule_id: formData?.id,
        goal_id: formData?.parent_id,
        template: formData?.templateSelected?.split(" ")[0],
        name: formData?.name,
        start_time: formData?.Cadence_schedule,
        participations: formData?.participations,
        recurrence: formData?.recurrence,
        custom_frequency: formData?.custom_frequency,
        ...data,
      };
      const res = await api.put(baseURL + "/schedule/", payload);
      toast.success("Meeting  Scheduled Successfully!");
      setTimeout(() => {
        onClose();
      }, 1000);
    } catch (error) {
      console.error(error);
      toast.error("Update Failed. Please Try Again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" className="z-50">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Box>
            <svg
              width="32"
              height="8"
              viewBox="0 0 32 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="4" cy="4" r="4" fill="#92CAC0" />
              <circle cx="16" cy="4" r="4" fill="#F4DB77" />
              <circle cx="28" cy="4" r="4" fill="#EDB0B0" />
            </svg>
          </Box>
          <Box mt={2}>
            <p className="text-xl">Schedule A Meeting</p>
          </Box>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box mb={4}>
            <label className="block text-sm font-medium mb-1">
              Meeting Name
            </label>
            <Input
              type="text"
              backgroundColor="#F7F8FA"
              style={{ fontSize: "12px" }}
              _placeholder={{ color: "#9398AD" }}
              value={formData?.name}
              onChange={handleMeeting}
              placeholder="Enter Meeting Name"
              maxLength={50}
            />
            {errors?.name && (
              <Box className="text-xs " color="red.500" mt={1}>
                Meeting Name Is Required
              </Box>
            )}
          </Box>

          <Box
            className="h-full"
            display="flex"
            flexWrap="wrap"
            mb={4}
            gap={4}
            alignItems="center"
          >
            {/* Cadence Label */}
            <Box
              flex="0.2"
              display={{ base: "none", md: "flex" }}
              alignItems="bottom"
              mb={{ base: 2, md: 0 }}
            >
              <label className="flex items-center text-sm space-x-1">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.9711 0C4.10106 0 4.22569 0.0516249 4.31758 0.143518C4.40948 0.23541 4.4611 0.360044 4.4611 0.49V1.4063H9.723V0.4963C9.723 0.366344 9.77462 0.24171 9.86652 0.149818C9.95841 0.0579249 10.083 0.0063 10.213 0.0063C10.343 0.0063 10.4676 0.0579249 10.5595 0.149818C10.6514 0.24171 10.703 0.366344 10.703 0.4963V1.4063H12.6C12.9712 1.4063 13.3272 1.5537 13.5897 1.8161C13.8522 2.0785 13.9998 2.43442 14 2.8056V12.6007C13.9998 12.9719 13.8522 13.3278 13.5897 13.5902C13.3272 13.8526 12.9712 14 12.6 14H1.4C1.02882 14 0.672829 13.8526 0.410298 13.5902C0.147767 13.3278 0.000185591 12.9719 0 12.6007L0 2.8056C0.000185591 2.43442 0.147767 2.0785 0.410298 1.8161C0.672829 1.5537 1.02882 1.4063 1.4 1.4063H3.4811V0.4893C3.48129 0.359465 3.53299 0.235012 3.62487 0.14327C3.71674 0.0515286 3.84126 -1.32484e-07 3.9711 0Z"
                    fill="#415070"
                  />
                </svg>
                <span className="text-[#415070]">Cadence</span>
              </label>
            </Box>

            {/* Schedule Field */}
            <Box flex="0.4" className="h-full" mb={{ base: 3, md: 0 }}>
              <label className="block text-xs mb-1">Schedule</label>
              <Input
                width="100%"
                style={{ fontSize: "12px" }}
                type="datetime-local"
                value={
                  formData?.Cadence_schedule
                    ? formatLocalDateString(formData.Cadence_schedule)
                    : ""
                }
                onChange={handleDateTimeChange}
                backgroundColor="#F7F8FA"
                color="#415070"
                _placeholder={{ color: "#9398AD" }}
              />
            </Box>

            {/* Recurrence Field */}
            <Box
              flex="0.4"
              ml={{ base: 0, md: 4 }}
              display="flex"
              flexDirection="column"
            >
              <label className="block text-xs mb-1">Recurrence</label>
              <div className="w-full">
                <Select
                  style={{
                    width: "100%", // Full width of the parent container
                    maxWidth: "220px",
                    fontSize: "12px",
                    height: "40px",
                    lineHeight: "40px",
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                  }}
                  className="custom-select"
                  value={formData?.recurrence}
                  onChange={handleRecurrenceChange}
                  placeholder="Select Recurrence"
                  options={ReccurenceData.map((item) => ({
                    label: item.title,
                    value: item.value,
                  }))}
                  dropdownStyle={{
                    zIndex: 10500,
                  }}
                />
              </div>
            </Box>

            {/* Custom Recurrence Modal */}
            <CustomRecurrencePage
              isOpen={isCustomModalOpen}
              handleClose={handleCustomModalClose}
              onSave={setData}
            />
          </Box>

          {errors?.Cadence_schedule && (
            <Box className="text-xs " color="red.500" mt={1}>
              Schedule Is Required
            </Box>
          )}

          <Box display="flex" alignItems="center" mb={4}>
            <Box flex="0.2">
              <Box className="flex justify-start items-center h-full">
                <label className="flex justify-start h-full text-sm space-x-1 mb-1">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.01419 7.01245C6.75133 7.27395 6.60293 7.62904 6.60156 7.99982C6.60156 8.37112 6.74906 8.72722 7.01161 8.98977C7.27416 9.25232 7.63026 9.39982 8.00156 9.39982C8.37234 9.39845 8.72743 9.25005 8.98893 8.98719"
                      stroke="#415070"
                      stroke-width="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8.00078 3.80005C7.1701 3.80005 6.35807 4.04637 5.66739 4.50788C4.9767 4.96938 4.43838 5.62533 4.12049 6.39278C3.8026 7.16023 3.71943 8.00471 3.88148 8.81943C4.04354 9.63415 4.44355 10.3825 5.03093 10.9699C5.61831 11.5573 6.36668 11.9573 7.1814 12.1193C7.99612 12.2814 8.8406 12.1982 9.60805 11.8803C10.3755 11.5625 11.0315 11.0241 11.493 10.3334C11.9545 9.64276 12.2008 8.83073 12.2008 8.00005"
                      stroke="#415070"
                      stroke-width="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 1C6.61553 1 5.26215 1.41054 4.11101 2.17971C2.95987 2.94888 2.06266 4.04213 1.53285 5.32122C1.00303 6.6003 0.86441 8.00776 1.13451 9.36563C1.4046 10.7235 2.07129 11.9708 3.05026 12.9497C4.02922 13.9287 5.2765 14.5954 6.63437 14.8655C7.99224 15.1356 9.3997 14.997 10.6788 14.4672C11.9579 13.9373 13.0511 13.0401 13.8203 11.889C14.5895 10.7378 15 9.38447 15 8M10.5974 5.40337L8.7 7.3"
                      stroke="#415070"
                      stroke-width="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.5876 3.46402L12.2003 3.80002L12.5363 1.41265C12.5387 1.38492 12.5329 1.35709 12.5194 1.3327C12.506 1.30832 12.4856 1.28849 12.4609 1.27576C12.4361 1.26302 12.4081 1.25796 12.3805 1.26121C12.3528 1.26447 12.3268 1.27589 12.3056 1.29402L10.7229 2.86865C10.5603 3.03239 10.4408 3.23377 10.3748 3.45489C10.3089 3.676 10.2986 3.90998 10.3449 4.13602L10.5969 5.40339L11.8643 5.65465C12.0903 5.70096 12.3243 5.69068 12.5454 5.62474C12.7665 5.55879 12.9679 5.43921 13.1316 5.27665L14.7055 3.69465C14.7237 3.67348 14.7352 3.64735 14.7384 3.61962C14.7416 3.5919 14.7365 3.56384 14.7237 3.53904C14.7109 3.51425 14.6909 3.49386 14.6664 3.48049C14.6419 3.46712 14.6139 3.46139 14.5862 3.46402"
                      stroke="#415070"
                      stroke-width="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className=" text-[#415070] ">Select Goal</span>
                </label>
              </Box>
            </Box>
            <Box flex="0.8">
              <TreeSelect
                showSearch
                size="large"
                className="w-full h-1/3"
                value={formData?.parent_val}
                dropdownStyle={{
                  maxHeight: 400,
                  overflow: "auto",
                  zIndex: 10500,
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                  textAlign: "start",
                }}
                placeholder="Assign Goal"
                allowClear
                onChange={(newVal) => {
                  checkTypeAndSave(newVal);
                }}
                treeData={parentDropdownItems}
              />
              {errors?.parent_id && (
                <Box className="text-xs" color="red.500" mt={1}>
                  Parent Goal Is Required
                </Box>
              )}
            </Box>
          </Box>

          <Box display="flex" alignItems="center" mb={4}>
            <Box flex="0.2">
              <Box className="flex justify-start items-center h-full">
                <label className="flex justify-start h-full text-sm space-x-1 mb-1">
                  <svg
                    width="19"
                    height="20"
                    viewBox="0 0 19 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 5.6875C2 5.10734 2.25022 4.55094 2.69562 4.1407C3.14102 3.73047 3.74511 3.5 4.375 3.5H12.925C13.5549 3.5 14.159 3.73047 14.6044 4.1407C15.0498 4.55094 15.3 5.10734 15.3 5.6875V8.78062C15.1427 8.75997 14.9839 8.74974 14.825 8.75H14.35V5.6875C14.35 5.3394 14.1999 5.00556 13.9326 4.75942C13.6654 4.51328 13.3029 4.375 12.925 4.375H4.375C3.99707 4.375 3.63461 4.51328 3.36737 4.75942C3.10013 5.00556 2.95 5.3394 2.95 5.6875V13.5625C2.95 13.9106 3.10013 14.2444 3.36737 14.4906C3.63461 14.7367 3.99707 14.875 4.375 14.875H5.8V15.3125C5.8 15.4613 5.81108 15.6071 5.83325 15.75H4.375C3.74511 15.75 3.14102 15.5195 2.69562 15.1093C2.25022 14.6991 2 14.1427 2 13.5625V5.6875ZM12.45 8.3125C12.45 8.42853 12.4 8.53981 12.3109 8.62186C12.2218 8.70391 12.101 8.75 11.975 8.75H7.225C7.09902 8.75 6.9782 8.70391 6.88912 8.62186C6.80004 8.53981 6.75 8.42853 6.75 8.3125C6.75 8.19647 6.80004 8.08519 6.88912 8.00314C6.9782 7.92109 7.09902 7.875 7.225 7.875H11.975C12.101 7.875 12.2218 7.92109 12.3109 8.00314C12.4 8.08519 12.45 8.19647 12.45 8.3125ZM4.85 6.5625C4.85 6.44647 4.90004 6.33519 4.98912 6.25314C5.0782 6.17109 5.19902 6.125 5.325 6.125H11.975C12.101 6.125 12.2218 6.17109 12.3109 6.25314C12.4 6.33519 12.45 6.44647 12.45 6.5625C12.45 6.67853 12.4 6.78981 12.3109 6.87186C12.2218 6.95391 12.101 7 11.975 7H5.325C5.19902 7 5.0782 6.95391 4.98912 6.87186C4.90004 6.78981 4.85 6.67853 4.85 6.5625ZM6.75 11.8125C6.75 11.2323 7.00022 10.6759 7.44562 10.2657C7.89102 9.85547 8.49511 9.625 9.125 9.625H14.825C15.4549 9.625 16.059 9.85547 16.5044 10.2657C16.9498 10.6759 17.2 11.2323 17.2 11.8125V15.3125C17.2 15.8927 16.9498 16.4491 16.5044 16.8593C16.059 17.2695 15.4549 17.5 14.825 17.5H9.125C8.49511 17.5 7.89102 17.2695 7.44562 16.8593C7.00022 16.4491 6.75 15.8927 6.75 15.3125V11.8125ZM9.125 10.5C8.79134 10.4999 8.46824 10.6077 8.212 10.8045C7.95576 11.0014 7.78264 11.2748 7.7228 11.5771L11.975 13.9274L16.2272 11.5771C16.1674 11.2748 15.9942 11.0014 15.738 10.8045C15.4818 10.6077 15.1587 10.4999 14.825 10.5H9.125ZM7.7 15.3125C7.7 15.6606 7.85013 15.9944 8.11737 16.2406C8.38461 16.4867 8.74707 16.625 9.125 16.625H14.825C15.2029 16.625 15.5654 16.4867 15.8326 16.2406C16.0999 15.9944 16.25 15.6606 16.25 15.3125V12.5851L12.2191 14.8129C12.1454 14.8536 12.061 14.8751 11.975 14.8751C11.889 14.8751 11.8046 14.8536 11.7308 14.8129L7.7 12.5851V15.3125Z"
                      fill="#415070"
                    />
                  </svg>

                  <span className=" text-[#415070] ">Template</span>
                </label>
              </Box>
            </Box>
            <Box flex="0.8">
              <TreeSelect
                style={{ fontSize: "12px", width: "100%" }}
                value={formData?.templateSelected}
                onChange={handleTemplateChange}
                placeholder="Choose Template"
                treeData={template}
                allowClear
                treeDefaultExpandAll
                dropdownStyle={{
                  maxHeight: 400,
                  overflow: "auto",
                  zIndex: 10500,
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                  textAlign: "start",
                }}
              />
              {errors?.templateSelected && (
                <Box className="text-xs" color="red.500" mt={1}>
                  Template Is Required
                </Box>
              )}
            </Box>
          </Box>

          <Box mb={4}>
            <label className="block text-sm font-medium mb-1 text-[#415070] ">
              Add Members
            </label>
            <Select
              name="participations"
              id="participations"
              dropdownStyle={{ zIndex: 10500 }}
              onChange={(val) => {
                setformData({ ...formData, participations: val });
              }}
              value={formData?.participations}
              mode="multiple"
              required
              className="w-full"
              placeholder="Select Participants"
            >
              {participations?.users?.length > 0 &&
                participations?.users?.map((participant, index) => (
                  <Select.Option
                    zIndex="10500"
                    value={participant?.user_id}
                    key={index}
                    disabled={currentEmployee?.user_id === participant?.user_id}
                  >
                    <div className="flex items-center gap-x-2">
                      <div
                        className="w-5 h-5 text-sm border border-black rounded-full flex items-center justify-center text-white relative"
                        style={{
                          backgroundColor: participant?.profile_image
                            ? "initial"
                            : getAvatarColor(participant?.username),
                        }}
                      >
                        {participant?.profile_image ? (
                          <img
                            src={participant?.profile_image}
                            alt="Profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "50%",
                              display: "block",
                            }}
                          />
                        ) : (
                          getInitials(participant?.username)
                        )}
                      </div>
                      <span>{participant?.username}</span>
                    </div>
                  </Select.Option>
                ))}
            </Select>
            {errors?.participations && (
              <Box className="text-xs mb-2" color="red.500" mt={1}>
                Member(s) Is/Are required
              </Box>
            )}
          </Box>
        </ModalBody>

        <ModalFooter
          position="sticky"
          bottom={0}
          bg="white"
          borderTop="1px solid #E2E8F0"
          boxShadow="0px -4px 8px -4px rgba(0, 0, 0, 0.1)"
          p={4}
        >
          {/* New button with Circle Icon on the left */}
          <Flex align="left">
            <Tooltip
              arrow={false}
              placement="rightTop"
              zIndex={105000}
              className="mr-5"
              title={
                isgoogleConnected
                  ? "Google Calendar connected"
                  : "Click here to schedule a meeting directly on Google Meet and integrate it seamlessly."
              }
            >
              <img
                src="/assets/images/google_calendar.png"
                alt="calendar"
                style={{
                  width: "24px",
                  height: "24px",
                  cursor: isgoogleConnected ? "not-allowed" : "pointer",
                  opacity: isgoogleConnected ? 0.5 : 1,
                }}
                onClick={() => {
                  if (!isgoogleConnected) {
                    navigate("/integrations");
                  }
                }}
              />
            </Tooltip>
          </Flex>

          {/* Cancel Button */}
          <Button
            variant="outline"
            borderRadius={"4px"}
            mr={3}
            px={"28px"}
            onClick={onClose}
          >
            Cancel
          </Button>

          {/* Save/Schedule Button */}
          <Button
            backgroundColor="#178FFF"
            textColor="#FFFFFF"
            px="28px"
            borderRadius="4px"
            border="none"
            _hover={{ backgroundColor: "#106ECC" }}
            onClick={() => {
              formData?.updateData ? handleUpdate() : handleSave();
            }}
          >
            {loading ? (
              <Spinner size="md" />
            ) : (
              <span> {formData?.updateData ? "Save" : "Schedule"}</span>
            )}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ScheduleMeetingModal;
